export default {
    locales: ["fr", "en"],
    fallback: "fr",
};
